import { motion } from "framer-motion";
import { Reveal, SplitLines, Stagger, Item } from "@/components/Reveal";

const FEATURES = [
  { title: "Italian kiln technology", text: "High-temperature roller kilns firing above 1200°C for a dense, fully vitrified body." },
  { title: "Digital glaze printing", text: "Multi-channel inkjet decoration for photorealistic marble, stone and wood surfaces." },
  { title: "Inline calibration", text: "Automated size and shade sorting so every carton in a container matches." },
  { title: "Export-grade packing", text: "Corner-protected, palletised and shrink-wrapped for long-haul sea freight." },
];

const SPECS = [
  ["Water absorption", "< 0.05%"], ["Breaking strength", "> 1500 N"], ["Surface hardness", "≥ 6 Mohs"], ["Frost resistance", "Resistant"],
  ["Abrasion (PEI)", "Class IV–V"], ["Stain resistance", "Class 5"], ["Thickness", "9 mm / 15 mm"], ["Standard", "ISO 13006 · EN 14411"],
];

export const Infrastructure = () => (
  <section id="infrastructure" data-testid="infrastructure-section" className="bg-[var(--bg)] py-28 lg:py-36">
    <div className="container-x">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal><p className="eyebrow mb-6">Infrastructure</p></Reveal>
          <SplitLines as="h2" inView className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight text-[var(--navy)]" lines={["Precision at", <>industrial <em className="italic text-[var(--mint)]">scale.</em></>]} />
          <Stagger className="mt-12 grid gap-8 sm:grid-cols-2">
            {FEATURES.map((f, i) => (
              <Item key={f.title}>
                <div className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[var(--mint)]">0{i + 1}</div>
                <h3 className="mt-2 font-display text-xl font-medium text-[var(--navy)]">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[var(--muted)]">{f.text}</p>
              </Item>
            ))}
          </Stagger>
        </div>
        <div className="lg:col-span-6 grid gap-5 sm:grid-cols-2">
          <Reveal className="relative aspect-[3/4] overflow-hidden rounded-[1.5rem] sm:mt-16">
            <img src="https://customer-assets-cm19k8pv.emergentagent.net/job_tile-showcase-55/artifacts/pslljyxm_WhatsApp%20Image%202026-09-20%20at%2015.47.31.jpeg" alt="SACMI kiln production line" className="h-full w-full object-cover" />
          </Reveal>
          <Reveal delay={0.15} className="glass rounded-[1.5rem] p-7" data-testid="tech-specs">
            <div className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[var(--mint)]">Technical Specifications</div>
            <dl className="mt-5">
              {SPECS.map(([k, v]) => (
                <motion.div key={k} className="flex items-baseline justify-between gap-4 border-b border-slate-200/80 py-2.5 text-sm">
                  <dt className="text-[var(--muted)]">{k}</dt><dd className="font-semibold text-[var(--navy)] text-right">{v}</dd>
                </motion.div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
